<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,12C15,12,2,12,2,12C2,12,2,10,2,10C2,10,5,10,5,10C5.55,10,6,9.55,6,9C6,9,6,7,6,7C6,7,8,7,8,7C8,7,8,8,8,8C8,8.55,8.45,9,9,9C9,9,13,9,13,9C13.55,9,14,8.55,14,8C14,8,14,5,14,5C14,5,15,5,15,5C15.55,5,16,4.55,16,4C16,3.45,15.55,3,15,3C15,3,13,3,13,3C12.45,3,12,3.45,12,4C12,4,12,7,12,7C12,7,10,7,10,7C10,7,10,6,10,6C10,5.45,9.55,5,9,5C9,5,5,5,5,5C4.45,5,4,5.45,4,6C4,6,4,8,4,8C4,8,2,8,2,8C2,8,2,3,2,3C2,2.45,1.55,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,15,12,15,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'StepChart',
} as DefineComponent
</script>
